import { Link } from "react-router-dom";
import "../../styles/AcademicsOverview.css";

function importAll(r) {
  return r.keys().map(r);
}

const images = importAll(
  require.context("../../assets/Images/gallery", false, /-300\.webp$/),
).sort();

export default function AcademicsOverview() {
  const [img1, img2, img3] = images;

  return (
    <section className="acad-section">
      <div className="acad-container">
        <header className="acad-header">
          <h2>Academics</h2>
          <p>
            Strong foundations, modern teaching practices, and personal guidance
            to help every child reach their full potential.
          </p>
        </header>

        <div className="acad-grid">
          <article className="acad-card">
            <img
              src={img1}
              alt="Modern curriculum and structured learning"
              width="300"
              height="225"
              loading="lazy"
              decoding="async"
            />
            <h3>Modern Curriculum</h3>
            <p>
              A well-structured curriculum that balances academics, creativity,
              and real-world skills.
            </p>
          </article>

          <article className="acad-card">
            <img
              src={img2}
              alt="Innovative teaching and classroom activities"
              width="300"
              height="225"
              loading="lazy"
              decoding="async"
            />
            <h3>Innovative Teaching</h3>
            <p>
              Activity-based learning, technology integration, and engaging
              classroom experiences.
            </p>
          </article>

          <article className="acad-card">
            <img
              src={img3}
              alt="Academic achievements and student success"
              width="300"
              height="225"
              loading="lazy"
              decoding="async"
            />
            <h3>Proven Results</h3>
            <p>
              Consistent academic excellence and strong performance across
              grades.
            </p>
          </article>
        </div>

        <div className="acad-cta">
          <Link to="/academics" className="acad-btn">
            Explore Academics
          </Link>
        </div>
      </div>
    </section>
  );
}
